import { z } from 'zod';

/** @deprecated */
export const TaskCategoryEnum = z.enum([
    'Repairs and Maintenance',
    'Weeds',
    'Pests',
    'Environment',
    'Biosecurity',
    'Animal Health and Husbandry',
    'Agronomy',
    'Irrigation',
    'Management',
]);

/** @deprecated */
export type TaskCategory = z.infer<typeof TaskCategoryEnum>;
